import { useQuery } from '@tanstack/react-query';

import { agent } from 'api/agent';

const useTranslationHome = (t: (name: string) => string) => useQuery({
  queryKey: ['translationHome'],
  queryFn: () => {
    const isOffline = localStorage.getItem('netStatus') === 'offline';

    if (!isOffline) {
      return agent.getClient()('auth/static/modules').then((response) => response.data);
    } else {
      return {
        crOptimizer: t('croptimizerText'),
        feasibilityCheck: t('feasibilityText'),
        industryApplicationBrief: t('industryBriefText'),
        productConverter: t('converterText'),
        productFinder: t('finderText'),
        prospectMap: t('prospectMapText'),
      };
    }
  },
});

export default useTranslationHome;
